export default function Quote(){return (
	<svg role="presentation" aria-hidden="true" className={'quoteIcon'} fill="inherit"
		 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 176.31 147.4">
		<path fill={'inherit'}
			  d="M77.05,147.4H0v-58.22c0-24.28,2.93-51.08,21.36-69.93C37.68,2.93,61.56,0,75.39,0h1.66v36.01h-2.5c-10.47,0-20.95,2.93-27.64,9.21-6.28,5.87-10.9,17.59-9.64,29.73h39.77v72.46ZM176.31,147.4h-77.07v-58.22c0-24.69,2.95-51.08,21.36-69.93,7.55-7.53,23.04-19.25,54.03-19.25h1.68v36.01h-2.52c-6.28,0-18.84.84-27.64,9.21-6.71,6.28-11.31,17.16-10.07,29.73h40.22v72.46Z"/>
	</svg>
)
}